<div class="h-full w-full">
  <video class="w-full" #media id="media" [poster]="poster"></video>
</div>
